module.exports = __webpack_public_path__ + "assets/68.jpg?d6a30471543b9a92db8d0b2889224f25";